import moment from "moment";
import type { PlanComplementarioCuenta } from "../types/planComplementario";

/** Sum all movimiento.montoMovimiento across cuenta[]. Returns null if nothing to show (no data / zero). */
export function sumPlanComplementarioMovimientos(
  cuenta: PlanComplementarioCuenta[] | undefined | null
): number | null {
  if (!cuenta || !Array.isArray(cuenta) || cuenta.length === 0) {
    return null;
  }

  let sum = 0;
  let hasAny = false;

  for (const c of cuenta) {
    const movs = c?.movimiento;
    if (!movs || !Array.isArray(movs)) {
      continue;
    }
    for (const m of movs) {
      if (m?.montoMovimiento == null || String(m.montoMovimiento).trim() === "") {
        continue;
      }
      const n = parseFloat(String(m.montoMovimiento).replace(/,/g, "").trim());
      if (!Number.isNaN(n)) {
        sum += n;
        hasAny = true;
      }
    }
  }

  if (!hasAny || sum === 0) {
    return null;
  }

  return sum;
}

export interface ComplementarioEstadoRow {
  fechaCorte: string;
  pdf: string;
  /** Label for UI, e.g. Al corte 17-04-2026 */
  labelAlCorte: string;
  /** Safe fragment for download filename */
  fileSlug: string;
}

/** Flatten cuenta[].estado[] entries that include a PDF (for Estado de Cuenta list). */
export function listComplementarioEstadosConPdf(
  cuenta: PlanComplementarioCuenta[] | undefined | null
): ComplementarioEstadoRow[] {
  const out: ComplementarioEstadoRow[] = [];
  if (!cuenta || !Array.isArray(cuenta)) {
    return out;
  }

  cuenta.forEach((c) => {
    const estados = c?.estado;
    if (!estados || !Array.isArray(estados)) {
      return;
    }
    estados.forEach((e) => {
      const pdf = e?.pdf?.trim();
      if (!pdf) {
        return;
      }
      const fechaCorte = (e.fechaCorte || "").trim();
      const parsed = moment(fechaCorte, "DD/MM/YYYY", true);
      const labelAlCorte = parsed.isValid()
        ? `Al corte ${parsed.format("DD-MM-YYYY")}`
        : fechaCorte
          ? `Al corte ${fechaCorte}`
          : "Al corte";
      const fileSlug = (fechaCorte || "complementario").replace(/\//g, "-").replace(/[^\w.-]+/g, "_");

      out.push({
        fechaCorte,
        pdf,
        labelAlCorte,
        fileSlug,
      });
    });
  });

  return out;
}
